import AcHtmlElement from "./html-element";
export const insertAfter = (newNode, referenceNode) => {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
};
export const insertBefore = (newNode, referenceNode) => {
    referenceNode.parentNode.insertBefore(newNode, referenceNode);
};
export const createElementFromString = (content, baseElement = 'div') => {
    return AcHtmlElement.create(baseElement).addHtml(content).element;
};
function isInViewport(element) {
    var rect = element.getBoundingClientRect();
    return (rect.top >= 0 && rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth));
}
